export const ru = {
    to_proceed: 'Сейчас вам доступен только поиск билетов и отелей. Чтобы перейти к их добавлению или бронированию, нужно',
    create_trip: 'создать заявку на командировку',
    wait_for_approval: 'дождаться согласования',
};
